import { useFormik } from "formik";
import React from "react";
import _ from 'lodash'
import { ReserveOrAssignBedModel } from "../../models/FormDataModel";
import ProDropDown from "../common/ProDropDown";
import ProCalendar from "../common/ProCalendar";
import ProInputNumber from "../common/ProInputNumber";
import ProFormFooter from "../common/ProFormFooter";
import ProInputText from "../common/ProInputText";
import useCensus from "../../hooks/useCensus";
import useCensusForm from "../../hooks/useCensusForm";
import { useClientService } from "../../hooks/useClientService";
import ProAutoComplete from "../common/ProAutoComplete";
import CensusFormValidator from "./validator/CensusFormValidator";
import { AddDays, FormattedDateString, FormattedToday } from "../../utilities/DateHelper";
import { OccupantTypeOptions } from "../../constants/ProConstants";
import ProCensusMoveClientForm from "./ProCensusMoveClientForm";
import useFormModelServices from "../../hooks/useFormModelServices";
import { Confirm } from "../../utilities/ProDialogs";
import { useHierarchyService } from "../../hooks/useHierarchyService";



const ProCensusForm = ({formModel, formAction, closeSideBar})=>{    

    const {data: {filter}, actions: {AssignOrReserveBed, MoveClient}} = useCensus({refreshTree:false}); 
    const {data:{selectedTreeNode}, actions:{RefreshTree}} = useHierarchyService();   
   
    const {filteredClient, SearchClient} = useClientService();
    const isFieldDisabled = _.isEmpty(formModel) ? false: true
    const {InitializeMoveClient } = useFormModelServices();  

    const GetModel = ()=>{
        var model = _.isEmpty(formModel)? ReserveOrAssignBedModel: _.isEqual(formAction, "MOVE")?InitializeMoveClient(formModel): formModel
        model = {...model, date:FormattedDateString(filter.date), startDate:_.isNull(model.startDate)?filter.date : model.startDate, action: formAction, bedId: selectedTreeNode.id}      
        return model;
    }

    const formik = useFormik({
        initialValues:  GetModel(),        
        validate: (data) => {
            return CensusFormValidator(data)           
        },
        onSubmit: (data) => {           
           handleSubmit(data);
           formik.resetForm();
           closeSideBar();
        },
    });

    const {actions:{onChanged}} = useCensusForm({formik})
   

    const handleSubmit = async (data)=>{
        switch(formAction){
            case "ASSIGN":
            case "RESERVE": 
            case "EDIT_ASSIGN":           
                await AssignOrReserveBed(data);               
                break; 
            case "MOVE":
                Confirm(async()=>{await MoveClient(data);},
                        ()=>{},
                        _.isEqual(data.occupantType.code, "CLIENT")?
                        `Move ${data.client.firstName} ${data.client.lastName} to Bed ${data.bed.name}?\nDependents assigned to beds must be moved separately.`
                        :`Move ${data.dependentName} to Bed ${data.bed.name}?\nDependents assigned to beds must be moved separately.`)  
                
                break;
            default:
                break;
        }
    }
   

    return (
        <form onSubmit={formik.handleSubmit}>
            <ProDropDown
                headerText="Occupant Type"
                id="occupantType"
                value={formik.values.occupantType}
                style={{ width: "100%", marginBottom: "2px", height: "40px" }}
                onChange={onChanged}
                options={OccupantTypeOptions} 
                optionLabel="name"
                placeholder="Occupant"
                formik={formik}
                error = "occupantType"
                disabled = {isFieldDisabled}
                required
            />    
           
            <ProAutoComplete
                id="client"                    
                labelText="Client"
                field = "fullName"
                formik = {formik}
                minLength={3}
                multiple={false}
                value={formik.values.client}
                suggestions = {filteredClient}
                completeMethod = {SearchClient}                        
                onChange={onChanged}
                error = "client"
                disabled = {isFieldDisabled}
                required
                    />               
           {(_.get(formik.values.occupantType, "code") === "DEPENDENT") && <ProInputText               
                id="dependentName"
                labelText="Dependent Name"
                value={formik.values.dependentName}
                onChange={onChanged}
                formik={formik}
                error="dependentName" 
                disabled = {isFieldDisabled}
                required                       
                />    }                  
            <ProCalendar 
                id="startDate" 
                placeholder="Start Date"
                value = {formik.values.startDate}
                onChange={onChanged}                
                style={{ width: "100%", marginBottom: "2px", height: "40px" }}
                formik={formik}               
                maxDate= {FormattedToday}
                error = "startDate"
                required               
                disabled = {!_.isEqual(formAction, "EDIT_ASSIGN")}/>   
            <ProCalendar 
                id="endDate" 
                placeholder="End Date"
                value = {formik.values.endDate}
                onChange={onChanged}                
                style={{ width: "100%", marginBottom: "2px", height: "40px" }}
                formik={formik}
                error = "endDate"
                minDate= {AddDays(formik.values.startDate, 1)}
                disabled = {isFieldDisabled && !_.isEqual(formAction, "EDIT_ASSIGN")}               
                required/>  
            <ProInputNumber
                id="stayDuration"
                labelText="Length Of Stay"                
                value={formik.values.stayDuration}
                onChange={onChanged}
                formik={formik}
                placeholder="Duration"
                error="stayDuration"
                minValue = {1}
                disabled = {isFieldDisabled && !_.isEqual(formAction, "EDIT_ASSIGN")}
                required
                /> 
                {_.isEqual(formAction, "MOVE") &&  <ProCensusMoveClientForm formik={formik} onChanged={onChanged}/> }
            <ProFormFooter onSave={() => console.log("Save")}  onCancel={closeSideBar} enableOnDirty={formik.dirty ||_.isEqual(formAction, "ASSIGN") } />                     
        </form>
    )



}

export default ProCensusForm;